import dom from "../../../dist/jsx-render/dom"
import { ColumnBase } from "./ColumnBase";
import { ITableColumn } from "./ITableColumn";
import { app } from "../../Frame/App";
import { MsoTable } from "./MsoTable";

export class ColumnDate extends ColumnBase {
    protected useTime: boolean;

    public constructor(table: MsoTable, def: ITableColumn, protected rootId: string) {
        super(table, def, rootId);
        this.useTime = def.useTime;
    }

    getCellClass(): string {
        if (this.isEditable) {
            return super.getCellClass() + " mt-textedit";
        }
        else {
            return super.getCellClass();
        }
    }

    public getContent(row: any): HTMLElement {
        return <span>{app.getDateString(row[this.def.dataField], this.useTime) ?? '\u00A0'}</span>;
    }

    public isFilterVisible(model: any): boolean {
        if (this.filteredItems) {
            let value = model[this.field];
            let date = "";
            if (!value || value.trim() == "")
                date = null;
            else
                date = value.split('T')[0];
            return date in this.filteredItems;
        }
        return true;
    }

    public compare(modelA: any, modelB: any, asc: boolean): number {
        let aDate = app.anyToDate(modelA[this.field]);
        let bDate = app.anyToDate(modelB[this.field]);

        let aValue = aDate != null ? aDate.valueOf() : 0;
        let bValue = bDate != null ? bDate.valueOf() : 0;
        if (asc) {
            return aValue - bValue;
        }
        else {
            return bValue - aValue;
        }
    }
}